import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TCategory } from 'data';
import { PreparedCategoryData } from 'utils';
import { sliceKey as name } from './utils';
import { PopularCategoriesState } from './types';

export const initialState: PopularCategoriesState = {
	data: [],
	isModalOpen: false,
	modalData: {} as PreparedCategoryData,
};

const PopularCategoriesSlice = createSlice({
	name,
	initialState,
	reducers: {
		openModal(state) {
			state.isModalOpen = true;
		},
		closeModal(state) {
			state.isModalOpen = false;
		},
		setModalData(state, action: PayloadAction<{ data: PreparedCategoryData }>) {
			const { data } = action.payload;
			state.modalData = data;
		},
		setPopularCategoriesData(state, action: PayloadAction<{ categoriesData: TCategory[] }>) {
			const { categoriesData } = action.payload;
			state.data = categoriesData;
		},
	},
});

export const {
	actions: popularCategoriesActions,
	reducer: popularCategoriesReducer,
	name: popularCategoriesName,
} = PopularCategoriesSlice;

export const { setPopularCategoriesData } = popularCategoriesActions;

export const popularCategoriesInitialState = initialState;
